<template>
  <RCVExplorer/>
</template>

<style>
  div.jsoneditor-tree {
    max-height: 700px;
  }
  .json-raw-viewer > div > div > div > div.jsoneditor-tree {
    max-height: 350px!important;
  }
  .json-host-config > div > div > div > div.jsoneditor-tree {
    min-height: 50px!important;
    max-height: 700px!important;
  }
  .json-host-info > div > div > div > div.jsoneditor-tree {
    min-height: 50px!important;
    max-height: 700px!important;
  }
  .json-raw-viewer > div > div > div.jsoneditor-menu {
    display: none!important;
  }
  div.jsoneditor-modes {
    display: none !important;
  }
  div.jsoneditor {
    border: none!important;
  }
  div.jsoneditor-menu {
    background-color: #6c757d !important;
    border-bottom: none !important;
  }

  @media (min-width: 768px) {
    .btn-with-margin {
      margin-right: 10px;
    }
  }

  body {
    overflow-y: scroll!important;
  }
</style>

<script>
import RCVExplorer from './components/RCVExplorer.vue';

export default {
  name: 'App',
  components: {
    RCVExplorer
}
}
</script>
